import { render, staticRenderFns } from "./PromotionalSlide.vue?vue&type=template&id=aa2566d0&scoped=true"
import script from "./PromotionalSlide.vue?vue&type=script&lang=js"
export * from "./PromotionalSlide.vue?vue&type=script&lang=js"
import style0 from "./PromotionalSlide.vue?vue&type=style&index=0&id=aa2566d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2566d0",
  null
  
)

export default component.exports